<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h6 class="card-title">ایجاد کارمند</h6>
        <form class="border" @submit.prevent="onSubmit" @keydown="customer.errors.clear($event.target.name) && project.errors.clear($event.target.name)">
          <div class="border">
            <h5>اطلاعات مشتری</h5>
            <div class="form-row d-flex justify-content-center">
                <div class="col-md-3 mb-3">
                    <label for="validationCustom01">نام مشتری
                        <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="نام مشتری را وارد کنید!" name="first_name" v-model="customer.first_name">
                    <span class="help text-danger" v-if="customer.errors.has('first_name')" v-text="customer.errors.get('first_name')"></span>
                </div>
                <div class="col-md-3 mb-3">
                    <label for="validationCustom02">نام خانوادگی مشتری
                        <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="نام خانوادگی مشتری را وارد کنید!"
                        name="last_name" v-model="customer.last_name">
                    <span class="help text-danger" v-if="customer.errors.has('last_name')" v-text="customer.errors.get('last_name')"></span>
                </div>
                <div class="col-md-3 mb-3">
                    <label for="validationCustom02">کد ملی
                        <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="کد ملی را وارد کنید!" name="customer.identification" v-model="customer.identification">
                    <span class="help text-danger" v-if="customer.errors.has('identification')" v-text="customer.errors.get('identification')"></span>
                </div>
            </div>
            <div class="form-row d-flex justify-content-center">
                <div class="col-md-3 mb-3">
                    <label for="validationCustom02">تلفن همراه
                        <span class="text-danger">*</span>
                    </label>
                    <input type="number" class="form-control" placeholder="شماره موبایل را وارد کنید!"
                        name="mobile" v-model="customer.mobile">
                    <span class="help text-danger" v-if="customer.errors.has('mobile')" v-text="customer.errors.get('mobile')"></span>
                </div>
                <div class="col-md-3 mb-3">
                    <label for="validationCustom02">تلفن همراه(دوم)
                    </label>
                    <input type="number" class="form-control" placeholder="شماره موبایل را وارد کنید!"
                        name="mobile2"  v-model="customer.mobile2">
                    <span class="help text-danger" v-if="customer.errors.has('mobile2')" v-text="customer.errors.get('mobile2')"></span>
                </div>
                <div class="col-md-3 mb-3">
                    <label for="validationCustom02">تلفن ثابت

                    </label>
                    <input type="number" class="form-control" placeholder="شماره تلفن را وارد کنید!" name="phone" v-model="customer.phone">
                    <span class="help text-danger" v-if="customer.errors.has('phone')" v-text="customer.errors.get('phone')"></span>
                </div>
            </div>
            <div class="form-row d-flex justify-content-center">
                <div class="col-md-6 mb-3">
                    <label for="validationCustom02">آدرس ایمیل
                    </label>
                    <input type="email" class="form-control" placeholder="آدرس ایمیل را وارد کنید!" name="email" v-model="customer.email">
                    <span class="help text-danger" v-if="customer.errors.has('email')" v-text="customer.errors.get('email')"></span>
                </div>
            </div>
          </div>
          <div class="border">
            <h5>اطلاعات پروژه</h5>
            <div class="form-row d-flex justify-content-center">
              <div class="col-md-4 mb-3">
                  <label for="validationCustom01">عنوان
                      <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" placeholder="عنوان پروژه را وارد کنید!" name="name" v-model="project.name">
                  <span class="help text-danger" v-if="project.errors.has('name')" v-text="project.errors.get('name')"></span>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">انتخاب روش آشنایی
                  <span class="text-danger">*</span>
                </label>
                <v-select v-model="project.introduction" :options="options" name="introduction" label="introduction"></v-select>
                <span class="help text-danger" v-if="project.errors.has('introduction')" v-text="project.errors.get('introduction')"></span>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center">
                <div class="col-md-4 mb-3">
                  <label for="validationCustom02">آدرس
                      <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" placeholder="آدرس را وارد کنید!" name="address" v-model="project.address">
                  <span class="help text-danger" v-if="project.errors.has('address')" v-text="project.errors.get('address')"></span>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="validationCustom02">توضیحات
                      <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" placeholder="توضیحات را وارد کنید!" name="description" v-model="project.description">
                  <span class="help text-danger" v-if="project.errors.has('description')" v-text="project.errors.get('description')"></span>
                </div>
            </div>
          </div>
          <div class="btn-group d-flex justify-content-center">
            <button class="btn btn-success col-md-2 my-3 btn-pulse" type="submit"
              :disabled="project.errors.any() && customer.errors.any()">ذخیره</button>
            <router-link :to="{name: 'projects.index'}" class="btn btn-dark col-md-2 my-3" type="button"><span
                class="text-white">بازگشت</span></router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectInformation',
  props: ['projectData', 'customerData', 'options'],
  data () {
    return {
      customer: new this.$form({
        first_name: '',
        last_name: '',
        identification: '',
        mobile: '',
        mobile2: '',
        phone: '',
        email: ''
      }),
      project: new this.$form({
        name: '',
        introduction: '',
        address: '',
        description: ''
      })
    }
  },
  mounted () {
    this.project.getData(this.projectData)
    this.customer.getData(this.customerData)
    this.customer.first_name = this.customerData.name.split(' ')[0]
    this.customer.last_name = this.customerData.name.split(' ')[1]
  },
  methods: {
    onSubmit () {
      this.$send.submit('patch', 'api/project/customer/' + this.$route.params.id, this.customer.data())
        .then(response => {
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'اطلاعات مشتری موفقیت ویرایش شد!',
            'success', {
              button: 'باشه'
            })
          this.$parent.getProject()
        }).catch(error => {
          this.customer.onFail(error.errors)
        })
      this.$send.submit('patch', 'api/projects/' + this.$route.params.id, this.project.data())
        .then(response => {
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'اطلاعات پروژه موفقیت ویرایش شد!',
            'success', {
              button: 'باشه'
            })
        }).catch(error => {
          this.project.onFail(error.errors)
        })
    }
  }
}
</script>

<style>

</style>
